import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { LOCALIZATION_PAGES } from 'utils/constants';
import { API_ENDPOINTS } from 'utils/constants';

const path = API_ENDPOINTS.SEAT_TYPES;

const useCreateSeatType = seatType => {
  const { t } = useTranslation(LOCALIZATION_PAGES.SEAT_TYPES);
  const { showNotification } = useRoot();

  const [{ result: createSeatTypeResult, loading: loadingCreateSeatType, error }, createSeatType] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.POST,
    data: seatType,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('alert_create_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (createSeatTypeResult) {
      showNotification({
        message: t('alert_create_success'),
      });
    }
  }, [createSeatTypeResult, showNotification, t]);

  return [{ createSeatTypeResult, loadingCreateSeatType, error }, createSeatType];
};

export default useCreateSeatType;
